import { useContext } from 'react';
import { Box, Divider } from '@mui/material';
import { Grid } from '@mui/system';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import ProcessManagementQuestions from 'pages/ProcessManagementQuestions/ProcessManagementQuestions';
import DelegationSection from './components/DelegationSection';
import ProcessManagementDocumentsUpload from './ProcessManagementDocumentsUpload/ProcessManagementDocumentsUpload';

const ProcessManagementPortal = () => {
  const { task } = useContext(TaskContext) as unknown as TaskContextType;
  const isOnlyDocumentRequest = task.paired_questionnaire === null;

  if (isOnlyDocumentRequest) {
    return (
      <>
        <ProcessManagementDocumentsUpload />
        <Box sx={{ mt: 4, px: 3 }}>
          <DelegationSection />
        </Box>
      </>
    );
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 5 }}>
          <ProcessManagementDocumentsUpload />
        </Grid>
        <Grid size={{ xs: 2 }} style={{ display: 'flex', justifyContent: 'center' }}>
          <Divider orientation="vertical" style={{ backgroundColor: '#BDC4CB', height: '100%' }} />
        </Grid>
        <Grid size={{ xs: 5 }}>
          <ProcessManagementQuestions />
        </Grid>
      </Grid>
      <Box sx={{ mt: 4, px: 3 }}>
        <Divider sx={{ mb: 3 }} />
        <DelegationSection />
      </Box>
    </>
  );
};

export default ProcessManagementPortal;
